// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__2_trd","Label":"Checkbox_Label__3O-8Y","InputElement":"Checkbox_InputElement__3j9ol","Invalid":"Checkbox_Invalid__3xMd9"};